var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8H12.5C10.9087 8 9.38258 8.63214 8.25736 9.75736C7.13214 10.8826 6.5 12.4087 6.5 14C6.5 15.5913 7.13214 17.1174 8.25736 18.2426C9.38258 19.3679 10.9087 20 12.5 20H15.5C16.0523 20 16.5 20.4477 16.5 21C16.5 21.5523 16.0523 22 15.5 22H12.5C10.3783 22 8.34344 21.1571 6.84315 19.6569C5.34285 18.1566 4.5 16.1217 4.5 14C4.5 11.8783 5.34285 9.84344 6.84315 8.34315C8.34344 6.84285 10.3783 6 12.5 6H16.5V3.38778C16.5 2.83668 17.1428 2.53563 17.5661 2.88843L21.9008 6.50066C22.2126 6.76052 22.2126 7.23948 21.9008 7.49934L17.5661 11.1116C17.1428 11.4644 16.5 11.1633 16.5 10.6122V8Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.51cf04b6ae3bc21dc840f98eea0e73bb.svg";
export { ForwardRef as ReactComponent };